import { WS10_HIDDEN } from '../constants';

export const blurAll = ()=>{
    const tempInput = document.createElement('input');
    tempInput.style.position = 'fixed';
    tempInput.style.left = '-1000px';
    tempInput.style.top = '-1000px';
    document.body.appendChild(tempInput);
    tempInput.focus();
    document.body.removeChild(tempInput);
};

/**
 * Show HTMLElement (or hide with show=false)
 * @param elementOrId
 * @param show
 */
export const showElement = (elementOrId: Element | null | string, show: boolean = true) => {
    const element = elementOrId instanceof Element ? elementOrId : document.getElementById(elementOrId || '');

    element?.classList.toggle(WS10_HIDDEN, !show);
};
